import { Vue } from 'vue-property-decorator';
import store from '../../../store';
import patientService from '../../../services/patientProfiles';
import tableMixin from '../../../Mixins/table';
import formMixin from '../../../Mixins/form';
import AdjustWalletDialog from './AdjustWalletDialog.vue';
import { debounce } from 'lodash';
import axios from 'axios';

export default Vue.extend({
  store,
  mixins: [tableMixin, formMixin],
  data: () => ({
    loading: false,
    search: '',
    patients: [],
    order: 'created_at',
    sort: 'desc',
    totalPatient: 0,
    patientPagination: {},
    patientHeaders: [
      {
        text: 'Patient ID',
        align: 'center',
        value: 'id',
        sortable: false,
        filterable: true,
      },
      {
        text: 'User ID',
        align: 'center',
        value: 'user_id',
        sortable: false,
        filterable: true,
      },
      {
        text: 'Name',
        align: 'center',
        value: 'fullName',
        sortable: false,
        filterable: true,
      },
      {
        text: 'Display name',
        align: 'center',
        value: 'display_name',
        sortable: false,
      },
      {
        text: 'Email',
        align: 'center',
        value: 'email',
        sortable: false,
      },
      {
        text: 'Tel',
        align: 'center',
        value: 'Tel',
        sortable: false,
      },
      {
        text: 'OTP',
        align: 'center',
        value: 'otp',
        sortable: false,
      },
      {
        text: 'OTP Generated At',
        align: 'center',
        value: 'otp_created_at',
        sortable: false,
      },
      {
        text: 'Support Pin',
        align: 'center',
        value: 'support_pin',
        sortable: false,
      },
      {
        text: 'Citizen ID',
        align: 'center',
        value: 'citizenid',
        sortable: false,
      },
      {
        text: 'Privileges',
        align: 'center',
        value: 'privilege',
        sortable: false,
      },
      {
        text: 'Emergency Contact',
        align: 'center',
        value: 'emergency_contact',
        sortable: false,
      },
      {
        text: 'Wallet',
        align: 'center',
        value: 'wallet',
        sortable: false,
      },
      {
        text: 'Action',
        align: 'center',
        value: 'action',
        sortable: false,
      },
    ],
  }),
  computed: {},
  watch: {
    patientPagination: {
      handler() {
        this.getPatientList().then((data) => {
          this.patients = data.items;
          this.totalPatient = data.total;
        });
      },
      deep: true,
    },
    search() {
      this.getPatientList().then((data) => {
        this.patients = data.items;
        this.totalPatient = data.total;
      });
    },
  },
  created() {},
  mounted() {},
  methods: {
    getPatientList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { page, itemsPerPage } = this.patientPagination;

        let query = {};
        if (itemsPerPage !== -1) {
          query.per_page = itemsPerPage;
          query.page = page;
        }
        query.order = this.order;
        query.sort = this.sort;
        if (this.search) {
          query.q = this.search;
        }

        patientService
          .all(query)
          .then((data) => {
            let items = data.data;
            const meta = data.meta;
            const total = meta.pagination.total;
            this.loading = false;
            resolve({
              items,
              total,
            });
          })
          .catch((err) => {
            this.loading = false;
            reject(err);
          });
      });
    },
    refresh() {
      this.getPatientList().then((data) => {
        this.patients = data.items;
        this.totalPatient = data.total;
      });
    },
    debounceInput: debounce(function (e) {
      this.search = e;
    }, 500),
    formatWallet: (number) => {
      return new Intl.NumberFormat('th-TH', { style: 'currency', currency: 'THB' }).format(number / 100);
    },
    handleCloseWalletDialog() {
      this.isOpen = false;
    },
    handleSubmitWalletDialog() {
      console.log('submit');
      this.isOpen = false;
    },
    formatOtpTime(value) {
      if (!value) return '-';

      // DB stores UTC. ISO strings with Z or +HH:MM parse correctly.
      // If the backend ever sends a naked "YYYY-MM-DD HH:mm:ss" without
      // timezone info, treat it as UTC rather than letting JS assume local.
      let isoValue = value;
      if (typeof value === 'string' && !/[Zz]|[+-]\d{2}:?\d{2}$/.test(value)) {
        isoValue = value.replace(' ', 'T') + 'Z';
      }

      const date = new Date(isoValue);
      if (isNaN(date.getTime())) return '-';

      // Omitting the timeZone option makes toLocaleString use the browser's
      // timezone. Omitting locale lets the browser pick its own format too.
      const absolute = date.toLocaleString(undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });

      const ageMs = Date.now() - date.getTime();
      const ageMin = Math.floor(ageMs / 60000);
      let relative;
      if (ageMs < 0) relative = 'in the future';
      else if (ageMin < 1) relative = 'just now';
      else if (ageMin < 60) relative = `${ageMin}m ago`;
      else if (ageMin < 1440) relative = `${Math.floor(ageMin / 60)}h ago`;
      else relative = `${Math.floor(ageMin / 1440)}d ago`;

      return `${absolute} (${relative})`;
    },
    openPrivateFileUrl(url) {
      const privateUrl = `${process.env.VUE_APP_API_ADMIN_LOCATION}file/private?url=${url}`;
      axios.get(privateUrl, { responseType: 'blob' }).then((response) => {
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const fileUrl = URL.createObjectURL(blob);
        window.open(fileUrl, '_blank');
      });
    },
  },
  components: {
    AdjustWalletDialog,
  },
});
